// import Dayjs from 'dayjs'
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(AdvancedFormat);
export type TDayjs = dayjs.Dayjs;
export function getDateByTimestamp(timestamp: number) {
  return dayjs.unix(timestamp).format('YYYY-MM-DD');
}
export function getTimeByTimestamp(timestamp: number) {
  return dayjs.unix(timestamp).format('HH:mm:ss');
}
export function getNowTimestamp() {
  return dayjs().unix();
}
export function timestamp2Dayjs(timestamp: number) {
  return dayjs.unix(timestamp);
}
export function getDayjs() {
  return dayjs();
}
export function getBrowserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'Etc/UTC';
  }
}

export function getRelativeTime(timestamp: number | string): string {
  const now = dayjs();
  const target =
    typeof timestamp === 'string'
      ? dayjs.unix(Number.parseInt(timestamp, 10))
      : dayjs.unix(timestamp);
  const diff = target.diff(now, 'second');
  const absDiff = Math.abs(diff);

  if (absDiff >= 86400) {
    // 大于等于1天
    return `${Math.floor(absDiff / 86400)}d`;
  }
  if (absDiff >= 3600) {
    // 大于等于1小时
    return `${Math.floor(absDiff / 3600)}h`;
  }
  if (absDiff >= 60) {
    // 大于等于1分钟
    return `${Math.floor(absDiff / 60)}m`;
  }
  return `${absDiff}s`;
}

export function formatTimestamp(timestamp: number): string {
  return dayjs.unix(timestamp).format('DD/MM/YYYY HH:mm:ss');
}

/**
 * Format timestamp for history display
 * Returns "Today" for today's date, otherwise returns MM/DD/YYYY format
 */
export function formatHistoryDate(timestamp: number): string {
  const date = dayjs.unix(timestamp);
  // const today = dayjs()

  return date.format('MM/DD/YYYY');
}

/**
 * Format timestamp for history time display
 * Returns HH:mm:ss format
 */
export function formatHistoryTime(timestamp: number): string {
  return dayjs.unix(timestamp).format('HH:mm:ss');
}

/**
 * Generate mock timestamp for testing
 * Can be for today, yesterday, or specific days ago
 */
export function getMockTimestamp(
  daysAgo = 0,
  hoursAgo = 0,
  minutesAgo = 0,
): number {
  return dayjs()
    .subtract(daysAgo, 'day')
    .subtract(hoursAgo, 'hour')
    .subtract(minutesAgo, 'minute')
    .unix();
}
export function formatTime(timestamp: number, isDay = false) {
  if (timestamp.toString().length > 10) {
    return dayjs(timestamp).format(isDay ? 'HH:mm' : 'MM/DD');
  }
  return dayjs.unix(timestamp).format(isDay ? 'HH:mm' : 'MM/DD');
}

/**
 * Format story time range from openedAt to closedAt
 * Returns formatted time range string
 */
export function formatStoryTimeRange(
  openedAt: number,
  closedAt: number,
): string {
  const openDate = dayjs.unix(openedAt);
  const closeDate = dayjs.unix(closedAt);

  const openFormatted = openDate.format('YYYY.MM.DD');
  const closeFormatted = closeDate.format('YYYY.MM.DD');

  return `${openFormatted} - ${closeFormatted}`;
}
